import { ActiveStateTokens, AvatarSizeTokens, AvatarTypeTokens, BorderRadiusTokens, ColorTokens, } from '@voltmoney/schema';
export const args = {
    // uris: [
    // 		'https://reactnative.dev/img/tiny_logo.png',
    // 		'https://reactnative.dev/img/tiny_logo.png',
    // 		'https://reactnative.dev/img/tiny_logo.png',
    // 		'https://reactnative.dev/img/tiny_logo.png',
    // 	],
    uri: 'https://reactnative.dev/img/tiny_logo.png',
    initialLetter: 'S',
    type: AvatarTypeTokens.SINGLE,
    size: AvatarSizeTokens.SM,
    borderWidth: 1,
    borderColor: ColorTokens.Primary_100,
    borderRadius: BorderRadiusTokens.BR5,
    active: ActiveStateTokens.INACTIVE,
    // uris: [
    // 	'https://reactnative.dev/img/tiny_logo.png',
    // 	'https://reactnative.dev/img/tiny_logo.png',
    // 	'https://reactnative.dev/img/tiny_logo.png',
    // 	'https://reactnative.dev/img/tiny_logo.png',
    // ],
    // uri: 'https://reactnative.dev/img/tiny_logo.png',
    // initialLetter: "S",
    // type: AvatarTypeTokens.MULTIPLE,
    // size: AvatarSizeTokens.LG,
    // borderWidth: 3,
    // borderColor: ColorTokens.Grey_100,
    // borderRadius: BorderRadiusTokens.BR4,
};
export const argTypes = {
    size: {
        control: 'select',
        options: [...Object.values(AvatarSizeTokens)],
    },
    type: {
        control: 'select',
        options: [...Object.values(AvatarTypeTokens)],
    },
    borderRadius: {
        control: 'select',
        options: [...Object.values(BorderRadiusTokens)],
    },
    borderColor: {
        control: 'select',
        options: [...Object.values(ColorTokens)],
    },
    active: {
        control: 'select',
        options: [...Object.values(ActiveStateTokens)],
    },
};
